import React from 'react'
import "./services.css"
import { BsCheck2 } from "react-icons/bs"
const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offfer</h5>
      <h2>Services</h2>

      <div className='container services__container'>
        <article className='service'>
          <div className='service__head'>
            <h3> UI/UX Design</h3>
          </div>
          <ul className='service__list'>
            <li>
              <BsCheck2 className='service__list-icon' />
              <p>HCI Design
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Brand Identity
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Web App Design
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Mobile App Design
              </p>
            </li>
          </ul>
        </article>

        {/* END OF UI/UX Design */}

        <article className='service'>
          <div className='service__head'>
            <h3>Web Development</h3>
          </div>
          <ul className='service__list'>
            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Website Redesigning
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Corporate Web Design
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Responsive Web Design 
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>24x7 Mantaince & Support
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Deployment and Integration
              </p>
            </li>
          </ul>
        </article>

        {/* END OF Web Development */}

        <article className='service'>
          <div className='service__head'>
            <h3> Programming</h3>
          </div>
          <ul className='service__list'>
            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Research & Data Analyst
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Image & Video Processing
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Audio or Video-Based Application
              </p>
            </li>

            <li>
              <BsCheck2 className='service__list-icon' />
              <p>Machine Learning & Deep Learning
              </p>
            </li>
          </ul>
        </article>

        {/* END OF Programming */}
      </div>
    </section>
  )
}

export default Services